// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MehOutlinedSvg from "@fishx/icons-svg/es/asn/MehOutlined";
import FishxIcon from '../components/FishxIcon';

var MehOutlined = function MehOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MehOutlinedSvg
  }));
};

MehOutlined.displayName = 'MehOutlined';
export default React.forwardRef(MehOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MehOutlined.js
// module id = 3107
// module chunks = 0